module.exports = __webpack_public_path__ + "static/media/subject.e7295d30.svg";